export enum UserStatus {
  ACTIVE = "ACTIVE",
  PASSIVE = "PASSIVE",
  ALL = "ALL",
}
